import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useConfirmEmail } from 'hooks/useConfirmEmail';
import { BasicPageContainer } from 'components/views/BasicPageContainer';
import { useRef } from 'react';

export const EmailConfirmationPage = () => {
    const [success, setSuccess] = useState(false);
    const location = useLocation();
    const { t } = useTranslation();
    const { confirmEmail, confirmEmailPending } = useConfirmEmail();

    const queryParams = new URLSearchParams(location.search);
    const encodedToken = queryParams.get('token');
    const phase = queryParams.get('phase');
    const hasCalledAPI = useRef(false);
    
    useEffect(() => {
        const confirm = async () => {
            if (encodedToken && !hasCalledAPI.current) {
                hasCalledAPI.current = true;
                const decodedToken = decodeURIComponent(encodedToken);
                const resp = await confirmEmail({ token: decodedToken });
                if (resp.success) {
                    setSuccess(true);
                } else {
                    hasCalledAPI.current = false;
                }
            }
        }
    
        confirm();
    }, [confirmEmail, encodedToken]);
    
    const getMessage = () => {
        if (!phase) return t('emailConfirm.emailIsConfirmed');
        
        switch (phase) {
            case 'CurrentEmailConfirmation':
                return t('emailConfirm.checkNewEmail');
            case 'NewEmailConfirmation':
                return t('emailConfirm.emailChangeCompleted');
            default:
                return t('confirmEmail.error');
        }
    };
    
    return <BasicPageContainer>
        <Box display='flex' justifyContent={'center'} alignItems={'center'} alignContent={'center'} height={'100%'}>
            {confirmEmailPending
            ? <CircularProgress />
            : success
                ? <Typography variant="h3" gutterBottom>
                    {getMessage()}
                </Typography>
            : <Typography variant="h3" gutterBottom color={'red'}>
                {t('confirmEmail.error')}
            </Typography>}            
        </Box>
    </BasicPageContainer>
}